module.exports = "<span><i class=\"glyphicon glyphicon-search\" *ngIf=\"this.searchIsDone\"></i><input class=\"btn btn-info btn-xs\" [@search]=\"searchState\" (@search.start)=\"this.onBegin($event)\" (@search.done)=\"this.onDone($event)\" id=\"autoComplete\" autocomplete=\"off\"></span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/search-field/search-field.component.pug
// module id = 1138
// module chunks = 1